import { appProviderHOC } from '@landing_academy/shared';

export const { AppProvider, AppContext } = appProviderHOC({
  formContattoOpened: false,
});
